<div class="notification-list" #scrollViewport>
    <div
        class="notification-item"
        *ngFor="let item of notifications(); trackBy: trackByNotificationId"
        (click)="handleShowDetail(item)"
        [ngClass]="{ 'un-read': item.Status === notificationStatusEnum.UnRead }"
        @showState
    >
        <div class="size-6 rounded-full bg-primary-100 flex-center">
            @switch (item.TypeNotification) {
                @case (notificationTypeEnum.Interact) {
                    <svg-icon src="/assets/icons/alert-1.svg" svgClass="size-4"></svg-icon>
                }
                @case (notificationTypeEnum.Discount) {
                    <svg-icon src="/assets/icons/discount-2.svg" svgClass="size-[13px]"></svg-icon>
                }
                @default {
                    <svg-icon src="/assets/icons/note.svg" svgClass="size-4"></svg-icon>
                }
            }
        </div>
        <div class="notification">
            <p class="n-title">{{ item.Title }}</p>
            <div class="n-content line-clamp-2" [innerHTML]="item.Content"></div>
            <div class="n-action" *ngIf="isShowInteract(item)">
                <button
                    type="button"
                    pnButton
                    size="tiny"
                    class="px-3 !text-sm !font-bold"
                    (click)="interactNotification(item, $event)"
                    i18n="@@notification.buttons.payment"
                >
                    Thanh toán
                </button>
            </div>
            <p class="n-createdAt">{{ item.CreatedDate | relativeTime }}</p>
        </div>
    </div>

    @if (loading()) {
        @for (item of [1, 2, 3, 4, 5]; track $index) {
            <div class="notification-item animate-pulse hover:!bg-inherit" @showState>
                <div class="size-4 rounded-full bg-slate-200"></div>
                <div class="notification grow">
                    <div class="h-5 w-2/3 rounded bg-slate-200"></div>
                    <div class="h-[18px] w-full rounded bg-slate-200"></div>
                    <div class="h-[18px] w-20 rounded bg-slate-200"></div>
                </div>
            </div>
        }
    }
</div>
